import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import DashboardLayout from '../components/Layout/DashboardLayout';

const ProtectedRoute = ({ useLayout = true }) => {
  const isLoggedIn = useSelector((state: any) => state.auth.isLoggedIn);
  const renderContent = () => {
    if (useLayout) {
      return (
        <DashboardLayout>
          <Outlet />
        </DashboardLayout>
      );
    }

    return <Outlet />;
  };

  return <>{isLoggedIn ? renderContent() : <Navigate to="/auth/login" />}</>;
};

export default ProtectedRoute;
